var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-10"},[_c('i',{staticClass:"fa-solid fa-spinner fa-spin-pulse fa-7x"}),_vm._v(" "),_c('h3',[_vm._v("Estamos preparando tu contenido")])])
}]

export { render, staticRenderFns }